<template>
    <span class="pricing-toggle">
      <button style="width:84px;"
        :class="{ 'active': period === 'monthly' }"
        @click="setPeriod('monthly')"
      >
        Monthly <span v-if="monthlycount>0" class="typecount">{{ monthlycount }}</span>
      </button>
      <button style="margin-top:10px;width:84px;"
        :class="{ 'active': period === 'yearly' }"
        @click="setPeriod('yearly')"
      >
        Yearly <span v-if="yearlycount>0" class="typecount">{{ yearlycount }}</span>
      </button>
    </span>
  </template>
  
  <script setup>
    import { ref } from 'vue'
    
    const emit = defineEmits(['period-changed'])
    
    const props = defineProps({
        initialPeriod: {
            type: String,
            default: 'monthly',
            validator: value => ['monthly', 'yearly'].includes(value)
        },
        monthlycount: Number,
        yearlycount: Number
    })

    const period = ref(props.initialPeriod)
    function setPeriod(newPeriod) {
        period.value = newPeriod
        emit('period-changed', newPeriod)
    }
  </script>
  
  <style scoped>
  .typecount {
    background-color: rgb(234, 72, 72);
    color:white;
    border-radius: 20px;
    padding:6px;
    width:20px;
    font-size: 14px;
    font-weight: bold;
  }
  .pricing-toggle {
    max-width: 300px;
    margin: 20px auto;
  }
  
  button {
    padding: 8px;
    margin: 0 5px;
    border: 1px solid #ccc;
    background: white;
    cursor: pointer;
    border-radius: 10px;
    font-size: 18px;
  }
  
  button.active {
    background: #099f45;
    color: white;
    border-color: #099f45;
  }
  
  .pricing-display {
    margin-top: 20px;
    text-align: center;
  }
  </style>